<template>
  <div class="">
    <v-header></v-header>
    <div class="wrap" style="margin-top: 90px;">
      <div class="pcBanner"><img src="../images/pcbanner.png"></div>
      <div class="xg_centre" style="">
        <div class="resultText">
          <div class="item">
            <h4><img src="../images/pc_icon_01.png">用户</h4>
            <span v-if="userInfo.userRole!='2'&&userInfo.userRole!='3'">{{userInfo.userName}}</span>
            <span v-else>{{cpresult.spare2}}</span>
          </div>
          <em></em>
          <div class="item">
            <h4><img src="../images/pc_icon_02.png">测评结果</h4>
            <span>{{cpresult.name}}</span>
          </div>
          <em></em>
          <div class="item">
            <h4><img src="../images/pc_icon_03.png">生成日期</h4>
            <span>{{cpresult.time}}</span>
          </div>
        </div>

        <div class="resultItem"  v-if="type==1">
          <div class="resultTitle">
            <h4>前言</h4>
          </div>
          <div class="mqianyan">
            <p v-html="qianyan"></p>
          </div>
        </div>
        <div class="resultItem">

          <div class="resultItemLeida">
            <div class="xgTItle flex">
              <h4><img src="../images/p4345.png">性格雷达图</h4>
            </div>
            <!-- <div class="leidatu" id="leida"></div> -->
            <cheping1 :list="list" :clist="clist"></cheping1>
            <p class="zhu">注：雷达图中，得分越接近六边形边角区域说明你的兴趣特点越典型，如雷达图接近正六边形，说明对所有的兴趣存在相同程度的喜好，也可能因未认真作答引起。</p>
          </div>
          <div class="resultItemFenxi">
            <div class="resultTitle">
              <h4>职业分析</h4>
            </div>
            <ul class="m_gaishu" style="margin-top: 20px;">
              <jobType v-for="(item,index) in qianyan" :key="index" :info="item.info"  :item="item"></jobType>
          	</ul>
          </div>
          <div class="mqianyan">
            <div class="xgTItle flex">
              <h4><img src="../images/p4345.png">
                <span v-if="type == '3'">专业选取</span>
                <span v-if="type == '1'">职业特质</span>
              </h4>
            </div>
            <p v-if="type != '3'" v-html="tz"></p>
            <p v-if="type == '3'" class="c-all">
              <a class="c-item" v-for="item in tz" @click="open(item)">{{item}}</a>
            </p>
          </div>
          <div class="resultItemShihe mqianyan">
            <div class="xgTItle flex">
              <h4><img src="../images/p4345.png"><span>适合的领域和职业</span></h4>
            </div>
            <!-- <dd v-html="zhiye"></dd> -->
            <p v-if="type != '3'" v-html="zhiye"></p>
            <p v-if="type == '3'" class="c-all">
              <a class="c-item" v-for="item in zhiye" @click="openjob(item)">{{item}}</a>
            </p>
          </div>

          <!-- <div class="resultItemShihe">
            <div class="xgTItle flex">
              <h4><img src="../images/p4345.png">职业兴趣维度介绍</h4>
            </div>
            <div class="nanduBox">
              <div class="nanduBoxWh">
                <h4>实际型(R)</h4>
                <ul>
                  <li>
                    <h5>职业倾向解读：</h5>
                    <p>有创造力,乐于创造新颖、与众不同的成果,渴望表现自己的个性,实现自身的价值,做事理想化,追求完美,不重实际,具有一定的艺术才能和个性。善于表达、怀旧心态较为复张</p>
                  </li>
                  <li>
                    <h5>职业兴趣特征：</h5>
                    <p>喜欢的工作要求目备艺术修养、创造力、表和直觉,并将其用于语言、行为、声音、颜色和形式的审美、思索和感受,具备相应的能力,不善于事务性工作</p>
                  </li>
                  <li>
                    <h5>适合职业推荐：</h5>
                    <p>
                      音乐类的音乐表演、作曲与作曲技术理论、音乐学、音乐教育、美术类的给画、美术学、美术教育、艺术设计学、书法、艺术设计、提影、戏剧影视美术设计、动、服装设计、戏剧影视美术设计、舞路类的舞路表演、舞蹈编导、戏剧影视文学广电影视戏剧类的播音与主持艺术、广播电视编导、录音艺术摄影摄像、影视照明、电视节目制作表演、导演、戏剧学
                    </p>
                  </li>
                </ul>
              </div>

            </div>
          </div> -->

          <div class="mqianyan">
            <div class="xgTItle flex">
              <h4><img src="../images/p4345.png">综合评价</h4>
            </div>
            <p v-html="fzyj"></p>
          </div>
        </div>

        <div class="mask" v-if="showcaozuo">
          <!-- <div class="maskA">
            <div class="maskAA">
              <p>{{jobobj.jobName}}</p>
              <img @click="showcaozuo = false" src="../../../src/assets/img/cha.png" />
            </div>
            <div class="ANAN">

            </div>
          </div> -->
          <div class="resultItem1">
            <div class="resultTitle">
              <h4>{{jobobj.jobName}}</h4>
              <img @click="showcaozuo = false" src="../../../src/assets/img/cha.png" />
            </div>
            <ul class="zhiyeList">
              <li>
                <h5>金融分析研究员</h5>
                <dl class="">
                  <dt><img src="../images/ic_01.png">毕业五年月薪：<span>11426元</span></dt>
                  <dd><img src="../images/ic_01.png">具体职位：<span>城市规划者</span></dd>
                </dl>
              </li>
              <li>
                <h5>法务</h5>
                <dl class="">
                  <dt><img src="../images/ic_01.png">毕业五年月薪：<span>11426元</span></dt>
                  <dd><img src="../images/ic_01.png">具体职位：<span>法官</span></dd>
                </dl>
              </li>
              <li>
                <h5>建筑工程</h5>
                <dl class="">
                  <dt><img src="../images/ic_01.png">毕业五年月薪：<span>11426元</span></dt>
                  <dd><img src="../images/ic_01.png">具体职位：<span>建筑工程师、气象员、土木工程师</span></dd>
                </dl>
              </li>
              <li>
                <h5>翻译</h5>
                <dl class="">
                  <dt><img src="../images/ic_01.png">毕业五年月薪：<span>11426元</span></dt>
                  <dd><img src="../images/ic_01.png">具体职位：<span>翻译</span></dd>
                </dl>
              </li>
              <li>
                <h5>IT工程师</h5>
                <dl class="">
                  <dt><img src="../images/ic_01.png">毕业五年月薪：<span>11426元</span></dt>
                  <dd><img src="../images/ic_01.png">具体职位：<span>IT经理</span></dd>
                </dl>
              </li>
            </ul>
          </div>
        </div>

        <!-- <div class="resultItem">
          <div class="resultTitle">
            <h4>学科爱好测评分析结果</h4>
          </div>
          <cheping2></cheping2>

          <div class="tubiaoJietu">
            <div class="xgTItle flex">
              <h4><img src="../images/p4345.png">图表解读</h4>
            </div>
            <div class="tubiaoJietuTable">
              <table>
                <tr>
                  <th>学科</th>
                  <td>政治</td>
                  <td>生物</td>
                  <td>历史</td>
                  <td>地理</td>
                  <td>物理</td>
                  <td>化学</td>
                </tr>
                <tr>
                  <th>得分</th>
                  <td>100</td>
                  <td>89</td>
                  <td>70</td>
                  <td>65</td>
                  <td>85</td>
                  <td>100</td>
                </tr>
              </table>
              <p>得分满分为100分</p>
              <div class="zong">综上，您的适合学科为：<span>物理、政治、生物。</span></div>
            </div>
          </div>
        </div>
        <div class="resultItem">
          <div class="resultTitle">
            <h4>适合专业推荐</h4>
          </div>
          <div class="shiheZhuanye">
            <h5><img src="../images/zy.png">本科专业推荐</h5>
            <ul class="xinggeWrapUl">
              <li><a href="">美术学类</a></li>
              <li><a href="">计算机类</a></li>
              <li><a href="">金融类</a></li>
              <li><a href="">海洋工程类</a></li>
              <li><a href="">核工程类</a></li>
              <li><a href="">航空航天类</a></li>
            </ul>
          </div>
        </div> -->

      </div>
    </div>
    <item7></item7>
  </div>
</template>

<script>
  import cheping1 from "../tubiao/cepingjieguo1.vue"
  import cheping2 from "../tubiao/cepingjieguo2.vue"
  import vHeader from '../../components/vHeader.vue'
  import item7 from '../../components/item7.vue'
  import jobType from '../../components/jobType.vue'
  import {
    getYear,
    getJobType
  } from '../../libs/tools.js'
  export default {
    name: "",
    components: {
      vHeader,
      item7,
      cheping1,
      cheping2,
      jobType
    },
    data() {
      return {
        list: [],
        clist: [],
        qianyan: null,
        type: 1,
        fzyj: '',
        tz: '',
        zhiye: '',
        result: {},
        jobobj: {},
        showcaozuo: false,
        cpresult: {},
        userInfo: this.$utils.getlocalStorage("userInfo"),
      }
    },
    methods: {
      getdata() {
        let _this = this;
        let name = _this.cpresult.name
        this.type = _this.cpresult.type
        if (_this.cpresult.type == 1) {
          this.list = _this.cpresult.count.map((item, index) => {
            return item.value
          })
          this.clist = _this.cpresult.count.map((item, index) => {
            return Object.assign({}, {
              'name': item.cname,
              max: 40
            })
          })
          name = _this.cpresult.name.split('').sort().join('')
          console.log(_this.cpresult)
          switch (name) {
            case 'EFJN':
              name = 'ENFJ';
              break;
            case 'EFNP':
              name = 'ENFP';
              break;
            case 'EJNT':
              name = 'ENTJ';
              break;
            case 'ENPT':
              name = 'ENTP';
              break;
            case 'EFJS':
              name = 'ESFJ';
              break;
            case 'EFPS':
              name = 'ESFP';
              break;
            case 'EJST':
              name = 'ESTJ';
              break;
            case 'EPST':
              name = 'ESTP';
              break;
            case 'FIJN':
              name = 'INFJ';
              break;
            case 'FINP':
              name = 'INFP';
              break;
            case 'IJNT':
              name = 'INTJ';
              break;
            case 'INPT':
              name = 'INTP';
              break;
            case 'FIJS':
              name = 'ISFJ';
              break;
            case 'FIPS':
              name = 'ISFP';
              break;
            case 'IJST':
              name = 'ISTJ';
              break;
            case 'IPST':
              name = 'ISTP';
              break;
          }
        } else if (_this.cpresult.type == 3) {
          let list = [{
            index: 'A'
          }, {
            index: 'S'
          }, {
            index: 'E'
          }, {
            index: 'C'
          }, {
            index: 'R'
          }, {
            index: 'I'
          }]
          for (let i in _this.cpresult.count) {
            switch (_this.cpresult.count[i].name) {
              case 'A':
                list[0] = _this.cpresult.count[i];
                break;
              case 'I':
                list[1] = _this.cpresult.count[i];
                break;
              case 'R':
                list[2] = _this.cpresult.count[i];
                break;
              case 'C':
                list[3] = _this.cpresult.count[i];
                break;
              case 'E':
                list[4] = _this.cpresult.count[i];
                break;
              case 'S':
                list[5] = _this.cpresult.count[i];
                break;
            }
          }
          this.list = list.map((item, index) => {
            return item.value
          })
          this.clist = list.map((item, index) => {
            return Object.assign({}, {
              'name': item.cname,
              max: _this.cpresult.count[0].value
            })
          })
        }
        let rq = {
          name: name
        }
        if (_this.cpresult.type == 1) {
          rq.type = _this.cpresult.type
        }
        this.$req.queryAllByLimit('tResult', {
          pageNum: 10,
          pageSize: 0,
          queryObj: rq
        }).then(function(response) {
          if (response.data != null) {
            _this.result = response.data[0]
          }
          if (_this.cpresult.type == '3') {
            if (_this.result.info != null && _this.result.info.indexOf('、') != -1) {
              _this.zhiye = _this.result.info.split('、')
            }
            if (_this.result.other != null && _this.result.other.indexOf('、') != -1) {
              _this.tz = _this.result.other.split('、')
            }
          }
        })
        if (_this.cpresult.type != 3) {
          _this.$http.get(_this.$resourcesUrl + "/xingge/" + name + "/qianyan.html").then(function(
            response) {
            if (response != null && response != "" && response != "\n") {
              _this.qianyan = response
            }
          })
          _this.$http.get(_this.$resourcesUrl + "/xingge/" + name + "/fzyj.html").then(function(
            response) {
            if (response != null && response != "" && response != "\n") {
              _this.fzyj = response
            }
          })
          _this.$http.get(_this.$resourcesUrl + "/xingge/" + name + "/tz.html").then(function(
            response) {
            if (response != null && response != "" && response != "\n") {
              _this.tz = response
            }
          })
          _this.$http.get(_this.$resourcesUrl + "/xingge/" + name + "/zhiye.html").then(function(
            response) {
            if (response != null && response != "" && response != "\n") {
              _this.zhiye = response
            }
          })
        } else if (_this.cpresult.type == 3) {
          _this.$http.get(_this.$resourcesUrl + "/xingge/" + this.qianyan[0].name + "/tz.html").then(function(
            response) {
            if (response != null && response != "" && response != "\n") {
              _this.qianyan[0].info = response
            }
          })
          _this.$http.get(_this.$resourcesUrl + "/xingge/" + this.qianyan[1].name + "/tz.html").then(function(
            response) {
            if (response != null && response != "" && response != "\n") {
              _this.qianyan[1].info = response
            }
          })
          _this.$http.get(_this.$resourcesUrl + "/xingge/" + this.qianyan[2].name + "/tz.html").then(function(
            response) {
            if (response != null && response != "" && response != "\n") {
              _this.qianyan[2].info = response
            }
          })
        }
      },
      open(item) {
        let _this = this;
        this.$req.queryAllByLimit('majorTable', {
          pageNum: 1,
          pageSize: 1,
          queryObj: {
            majorName: item
          }
        }).then(function(response) {
          console.log(response)
          if (response.data.length != 0) {
            let routeUrl = _this.$router.resolve({
              path: "/zyxq_zhuanyejieshao",
              query: {
                id: response.data[0].majorId
              }
            });
            window.open(routeUrl.href, '_blank')
          }

        })
      },
      openjob(item) {
        let _this = this;
        this.$req.queryAllByLimit('jobTable', {
          pageNum: 1,
          pageSize: 1,
          queryObj: {
            jobName: item
          }
        }).then(function(response) {
          console.log(response)
          if (response.status == '0') {
            if (response.data.length != 0) {
              _this.jobobj = response.data[0]
              _this.showcaozuo = true;
            }
          }
        })
      }
    },
    created() {
      let cpresult = this.$utils.getlocalStorage('cpresult')
      // cpresult.name = 'RCI'
      if (cpresult.type == 3) {
        this.qianyan = []
        cpresult.count[0].info = '';
        cpresult.count[1].info = '';
        cpresult.count[2].info = '';
        this.qianyan.push(cpresult.count[0])
        this.qianyan.push(cpresult.count[1])
        this.qianyan.push(cpresult.count[2])
        // this.qianyan.push(cpresult.count[3])
        // this.qianyan.push(cpresult.count[4])
        // this.qianyan.push(cpresult.count[5])
      }
      this.cpresult = cpresult
      console.log(getJobType())
      this.getdata()
    }


  }
</script>

<style>
  .t-heard {
    color: #29A7E1;
  }

  .xgTItle {}

  .xgTItle span {
    font-weight: 800;
  }

  .val {
    color: #e63233;
  }

  .c-all {
    display: flex;
    flex-wrap: wrap;

  }

  .c-item {
    font-size: 15px;
    font-weight: 800;
    padding: 8px 0px;
    color: #297abf;

  }


.resultItem1{
  width: 60%;
  height: 60%;
  background: rgb(255, 255, 255);
  border-radius: 30px;
  position: fixed;
  left: 50%;
  top: 50%;
  padding:0 20px;
  transform: translate(-50%, -50%);
  overflow: hidden;
}


  /* 遮罩层  ↓ */
  .mask {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 120;
    background-color: rgba(0, 0, 0, 0.7);
  }

  .maskA {
    width: 60%;
    height: 60%;
    background: rgb(255, 255, 255);
    border-radius: 30px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
  }

  .maskAA {
    width: 100%;
    height: 54px;
    background-image: url("../../assets/img/zzctop.png");
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 28px;
    padding-left: 28px;
    margin-bottom: 10px;
    box-sizing: border-box;
  }

  .maskAA img {
    width: 28px;
    height: 28px;
    cursor: pointer;
  }

  .ANAN {
    width: 100%;
    padding-bottom: 10px;
    padding-left: 50px;
    padding-right: 50px;
    padding-top: 20px;
    /* height: calc(100% - 170px); */
    overflow-y: scroll;
    height: 400px;
  }

  .maskAA p {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }

  .ANAN figure {
    display: flex;
    margin-bottom: 18px;

  }

  .ANAN figure span {
    margin-right: 15px;
    background-color: #F44F25;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 18px;
    border-radius: 15px;
    width: 25px;
    height: 25px;
  }

  .ANAN figure figcaption {
    font-size: 16px;
    /* line-height: 30px; */
    font-family: PingFang SC;
    font-weight: 500;
    color: #5A4F40;
  }
</style>



// WEBPACK FOOTER //
// src/views/mine/h_wdceping_result.vue